import { z } from "zod/v4";
import { ImportedContractSchema } from "../../schemas/ImportedContractSchema.js";
export const getInvalidFormatErrors = (contract) => {
    let parsingErrors = {};
    try {
        ImportedContractSchema.parse(contract);
    }
    catch (e) {
        parsingErrors = parseZodError(e);
    }
    return parsingErrors;
};
const parseZodError = (zodError) => {
    const formattedZodErrors = z.treeifyError(zodError);
    const validationErrors = {};
    for (const [field, issue] of Object.entries(formattedZodErrors.properties ?? {})) {
        validationErrors[field] = issue.errors;
    }
    return validationErrors;
};
